import './SurveysTheme.scss';

import { IdelinkModuleTheme } from '../../../configs/IdeLinkTheme';
import listDefaultIcon from '../assets/default_img_surveys.svg';
import iconBlack from '../assets/ic-survey-black.svg';
import emptyIcon from '../assets/ic-survey-empty.svg';
import iconWhite from '../assets/ic-survey-white.svg';

export const SurveysTheme: IdelinkModuleTheme = {
    className: 'idelink-theme il-theme-surveys',
    backgroundColor: '#4A84CC', //* prussian-blue
    emptyIcon,
    permissionIcon: iconBlack,
    permissionSelectedIcon: iconWhite,
    navbarIcon: iconWhite,
    listDefaultIcon,
};
